import { HttpError } from '../api/http'

export function formatErrorMessage(error: unknown): string {
  if (error instanceof HttpError) {
    const body = error.body as unknown

    // 1. Handle Array of validation issues (e.g. [ { "code": "...", "message": "..." } ])
    if (Array.isArray(body)) {
      const messages = body
        .map((err) => {
          if (typeof err === 'object' && err !== null && 'message' in err) {
            return String(err.message)
          }
          return JSON.stringify(err)
        })
        .filter(Boolean)
      if (messages.length > 0) return messages.join('. ')
    }

    // 2. Handle Object-style validation errors (Zod-like)
    if (body && typeof body === 'object') {
      const b = body as Record<string, unknown>
      // If it's a validation error, return a clean message
      if (b.code === 'invalid_union' || b.code === 'invalid_type') {
        return 'Invalid input parameters'
      }

      if (typeof b.message === 'string') {
        return b.message
      }

      if (typeof b.code === 'string') {
        return `Error: ${b.code}`
      }
    }

    // Fallback for errors with status code
    return `Request failed (${error.status})`
  }

  if (error instanceof Error) {
    return error.message
  }

  return String(error || 'An unexpected error occurred')
}
